import { Component, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { dateStringFromISO8601 } from '../../../../../../utils';

import { AccountService } from '../../../../../../services/account/account.service';
import { UnlinkedMembershipCustomerInboxItem } from '../../../../../../models/inbox';
import { InboxService } from '../../../../../../services/inbox/inbox.service';
import {
  ReviewUnlinkedMembershipCustomerModalComponent
} from './modals/review-unlinked-membership-customer-modal/review-unlinked-membership-customer-modal.component';

@Component({
  selector: 'app-inbox-unlinked-memberships',
  templateUrl: './inbox-unlinked-memberships.component.html',
  styleUrls: ['./inbox-unlinked-memberships.component.css']
})
export class InboxUnlinkedMembershipsComponent implements OnInit {

  public unlinkedCustomerInboxItems: UnlinkedMembershipCustomerInboxItem[];

  public loadingUnlinkedCustomerInboxItems = false;

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public accountService: AccountService,
    private inboxService: InboxService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.loadUnlinkedCustomerInboxItems();
  }

  public inboxItemsPresent() {
    return this.unlinkedCustomerInboxItems && (this.unlinkedCustomerInboxItems.length > 0);
  }

  public openReviewUnlinkedMembershipCustomerModal(unlinkedCustomerInboxItem: UnlinkedMembershipCustomerInboxItem) {
    const modalRef = this.modalService.open(ReviewUnlinkedMembershipCustomerModalComponent);
    modalRef.componentInstance.unlinkedCustomerInboxItem = unlinkedCustomerInboxItem;
    modalRef.componentInstance.savedCallback = () => {
      this.loadUnlinkedCustomerInboxItems();
    };
  }

  private loadUnlinkedCustomerInboxItems() {
    this.loadingUnlinkedCustomerInboxItems = true;

    this.inboxService
      .getUnlinkedMembershipCustomers()
      .then(unlinkedCustomerInboxItems => {
        this.unlinkedCustomerInboxItems = unlinkedCustomerInboxItems;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingUnlinkedCustomerInboxItems = false; });
  }

}
